import style from "@styles/pages/flow/boxes/Box.module.scss";
import { memo } from "react";
import { BoxTitles } from "../../BoxTitles";
import { BoxTypes } from "../../BoxTypes";
import { BoxValidations } from "../../BoxValidations";
import { FlowBox } from "../../FlowBox";
import { ReportFooter } from "../layout/ReportFooter";
import SourceBaseBox from "../layout/SourceBaseBox";

export default memo(({ id, data, selected, isConnectable }) => {
  const subline = () => {
    const str = FlowBox.getSublineByType(BoxTypes.BroadcastAudience, data);
    return str ? <div className={style.subline}>{str}</div> : null;
  };

  return (
    <SourceBaseBox
      id={id}
      selected={selected}
      valid={BoxValidations.validate(BoxTypes.BroadcastAudience, data)}
      title={BoxTitles.BroadcastAudience}
      isConnectable={isConnectable}
      footer={<ReportFooter id={id} />}
    >
      {subline()}
    </SourceBaseBox>
  );
});
